import {Pipe, PipeTransform} from '@angular/core';

/**
 * Return a value for a provided key from an enum
 */
@Pipe({
    name: 'key'
})
export class KeyPipe implements PipeTransform {
    transform(value: any, args?: Object): any {
        for (let index = 0; index < Object.values(args).length; index++) {
            if (Object.values(args)[index] === value) {
                return Object.keys(args)[index];
            }
        }
    }

}
